import FullPageCenterLoading from './FullPageCenterLoading';

export default FullPageCenterLoading;
